<template>
  <div>
    <Card style="padding-bottom: 40px">
      <div class="searchBox">
        <Row>
          <Form :label-width="100">
            <Col :span="5">
              <FormItem label="事件名称">
                <Input v-model="eventForm.eventTitle" @on-blur="getInformationReceivingData"
                       clearable
                       @on-clear.once="getInformationReceivingData('clean')"></Input>
              </FormItem>
            </Col>
            <Col :span="5">
              <FormItem label="事件类型">
                <Select transfer v-model="eventForm.eventType" clearable
                        @on-clear.once="eventClear"
                        @on-change="eventTypeChange">
                  <Option v-for="(item,index) in eventTypeList" :value="item.id" :label="item.name"
                          :key="index"></Option>
                </Select>
              </FormItem>
            </Col>
            <Col :span="5">
              <FormItem label="事件状态">
                <Select transfer v-model="eventForm.status" clearable
                        @on-clear.once="getInformationReceivingData('clean')"
                        @on-change="getInformationReceivingData">
                  <Option v-for="(item,index) in eventStatusList" :value="item.id" :label="item.name"
                          :key="index"></Option>
                </Select>
              </FormItem>
            </Col>
          </Form>
        </Row>
      </div>
      <Table
        :loading="InformationReceivingLoading"
        :columns="InformationReceivingColumns"
        :data="InformationReceivingData"
        :highlight-current-row="true"
      >
        <template #action="{ row, index }">
          <el-button  size="small" type="text" @click="gotoEmergeResponse(row)">查看
          </el-button>
        </template>
      </Table>
      <Page style="float: right;margin-top: 10px"
            show-sizer
            show-total
            :total="InformationReceivingTotal"
            :page-size="InformationReceivingPageSize"
            :page-size-opts="pageSizeOpts"
            :current-page="InformationReceivingCurrentPage"
            @on-change="InformationReceivingPageChange"
            @on-page-size-change="InformationReceivingPageSizeChange"
      ></Page>
    </Card>
  </div>
</template>
<script>
import {monitoringColumns} from './js/newInformation.js'
import {exportWord, getBase64Sync} from '@/utils/exportBriefDataDocx'
import EmergencyResponse from '@/views/emergencyResponse/emergencyResponse.vue'

export default {
  components: {EmergencyResponse},
  data() {
    return {
      seleRow: null,
      exportModal: false,
      exportList: [],
      eventForm: {
        eventTitle: '',
        eventStatus: '',
        eventType: '',
        eventCategory: '',
      },
      eventTypeList: [],// 事件类型列表
      EventCategorysList: [],// 事件类别列表
      eventStatusList: [],// 事件状态列表
      InformationReceivingLoading: true,
      InformationReceivingTotal: 0,
      InformationReceivingColumns: monitoringColumns,
      InformationReceivingData: [],
      InformationReceivingPageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],
      InformationReceivingCurrentPage: 1,
      curArea: ''
    }
  },
  mounted() {
    this.getInformationReceivingData()
    this.getUserData()
    this.getEventStatusList()
    this.getEventTypeList()
  },
  methods: {
    // 获取类型列表
    getEventTypeList() {
      this.$http.get(`/api/getEventTypesListByType?type=${1}`).then(res => {
        if (res.status === 200) {
          this.eventTypeList = res.data
        } else {
          this.$Message.error('获取事件类型列表失败')
        }
      })
    },
    gotoEmergeResponse(row) {
      this.seleRow = row
      this.$router.push({
        name: 'RoadEmergencyResponses',
        query: {
          id: row.id
        }
      })
    },
    getUserData() {
      this.$http.get('/api/getLowerLevelDepts').then(res => {
        console.log(res)
        if (res.status === 200) {
          this.curArea = res.data[0].indexCode
        }
      })
    },
    eventTypeChange() {
      this.getEventCategorysList()
      this.getInformationReceivingData()
    },
    eventClear() {
      this.eventForm.eventCategory = ''
      this.getInformationReceivingData()
    },
    // 获取状态列表
    getEventStatusList() {
      this.$http.get('/api/eventStatuss').then(res => {
        // console.log(res)
        this.eventStatusList = res.data.data
      })
    },
    // 获取信息接收数据
    getInformationReceivingData(value) {
      if (value === 'clean') {
        this.eventForm.eventStatus = null
        this.eventForm.eventType = null
        this.eventForm.eventTitle = null
      }
      if (this.eventForm.eventStatus === '') {
        this.eventForm.eventStatus = null
      }
      if (this.eventForm.eventCategory === '') {
        this.eventForm.eventCategory = null
      }
      if (this.eventForm.eventTitle === '') {
        this.eventForm.eventTitle = null
      }
      if (this.eventForm.eventType === '') {
        this.eventForm.eventType = null
      }
      let reqData = {
        page: this.InformationReceivingCurrentPage,
        size: this.InformationReceivingPageSize,
        ...this.eventForm,
        reportingChannels: 1
      }
      this.InformationReceivingLoading = true
      this.$http.post('/api/getMessageList', reqData).then(res => {
        this.InformationReceivingData = res.data.data
        this.InformationReceivingTotal = res.data.recordsTotal
        this.InformationReceivingLoading = false
      })
    },
    InformationReceivingPageChange(page) {
      this.InformationReceivingCurrentPage = page
      this.getInformationReceivingData()
    },
    InformationReceivingPageSizeChange(pageSize) {
      this.InformationReceivingPageSize = pageSize
      this.getInformationReceivingData()
    },
  }
}
</script>
<style scoped lang="less">
@import "css/InformationReceiving.less";
</style>
